import i18next from "i18next";
import I18nextBrowserLanguageDetector from "i18next-browser-languagedetector";
import I18NextHttpBackend from "i18next-http-backend";
import { initReactI18next } from "react-i18next";

// Legacy init for baback-office — remove once migrated to namespace-based CDN delivery
export default function initTranslationsLegacy(
  base: string,
  onMissingKey?: (key: string, lngs: readonly string[]) => void,
) {
  i18next
    .use(I18nextBrowserLanguageDetector)
    .use(I18NextHttpBackend)
    .use(initReactI18next)
    .init({
      debug: false,
      fallbackLng: "en",
      backend: {
        loadPath: `${base}/locales/{{lng}}.i18n.json`,
      },
      saveMissing: true,
      missingKeyHandler: (lngs, _ns, key) => {
        console.warn(`[i18n] Missing translation key "${key}" for: ${lngs.join(", ")}`);
        onMissingKey?.(key, lngs);
      },
    });
}
